import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import PropTypes from 'prop-types';
import { Container} from '@mui/material';

import Typography from '@mui/material/Typography';

import UserSettingsForm from './UserSettingsForm';
import CommonPaper from '../common/CommonPaper';
import CommonContainer, { SIZE_GOLDEN_RATIO } from '../common/CommonContainer';
import { styled } from '@mui/material/styles';
import { fetchUserDetails, updateAppUserSettings } from '../../actions/user-actions';
import CommonCenterSpinner from '../common/CommonCenterSpinner';
import CommonCenterContainer from '../common/CommonCenterContainer';

const StyledContainer = styled(Container)(({ theme }) => ({
  maxWidth: 'sm',
  marginTop: theme.spacing(4),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));


const UserSettings = ({ user, fetchUserDetails, updateAppUserSettings }) => {

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  if (!user) {
    return <CommonCenterSpinner />;
  }

  return (
     <StyledContainer>
            <Typography variant="h4" align="center" gutterBottom>
                   Ustawienia użytkownika
               </Typography>

          <UserSettingsForm
            initialValues={user}
            onSubmit={updateAppUserSettings}
          />
         </StyledContainer>
  );
};

UserSettings.propTypes = {
  user: PropTypes.object,
  fetchUserDetails: PropTypes.func,
  updateAppUserSettings: PropTypes.func,
};

const decorate = compose(
  connect(
    store => ({ user: store.user.profile }),
    dispatch => bindActionCreators({ fetchUserDetails, updateAppUserSettings }, dispatch)
  ),
);

export default decorate(UserSettings);
